export default {"src":"/_next/static/media/ecm-no-text.acc30ec2.svg","height":38,"width":42};